// action types
export const GET_STATS = "GET_STATS";

// mutation types
export const SET_STATS = "SET_STATS";
